import { render, staticRenderFns } from "./FedrampRequestAccessModal.vue?vue&type=template&id=04c1fac1&scoped=true&"
import script from "./FedrampRequestAccessModal.vue?vue&type=script&lang=js&"
export * from "./FedrampRequestAccessModal.vue?vue&type=script&lang=js&"
import style0 from "./FedrampRequestAccessModal.vue?vue&type=style&index=0&id=04c1fac1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1fac1",
  null
  
)

export default component.exports